module.exports = __webpack_public_path__ + "img/ic-expand.8d595c26.svg";